export default __webpack_public_path__ + "static/media/labyrinth.ad3ca0bf.svg";